import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ColumnModel from "../../../../../models/datasource/column";
import {aggregationSelectEvent} from '../../../../../services/query_builder_events';
import {aggregationPropType} from '../../../../../utils/query_utils';

export default class AggregationList extends Component {
    render() {
        const {
            column,
            aggregations,
            selectedAggregation,
            onHover,
            onLeave,
        } = this.props;
        if (column) {
            return (
                <>
                    <h5>Select an Aggregation</h5>
                    <ul className="aggregation-list w-list-unstyled">
                        {aggregations.map(aggregation => (
                            <li
                                key={aggregation.label}
                                className={`aggregation-item w-list-unstyled ${selectedAggregation === aggregation ? 'hover': ''}`}
                                onClick={() => { aggregationSelectEvent.emit(aggregation, column); }}
                                onMouseEnter={() => onHover(aggregation)}
                                onMouseLeave={() => onLeave()}
                            >
                                {aggregation.label} <span className="agg-column-name">{column.fullName}</span>
                            </li>
                        ))}
                    </ul>
                </>
            );
        }
    }
}

AggregationList.propTypes = {
    aggregations: PropTypes.arrayOf(aggregationPropType).isRequired,
    column: PropTypes.instanceOf(ColumnModel).isRequired,
    selectedAggregation: aggregationPropType,
    searchQuery: PropTypes.string,
    onHover: PropTypes.func.isRequired,
    onLeave: PropTypes.func.isRequired,
};

AggregationList.defaultProps = {
    searchQuery: '',
};
